export function hotlineQuery(number, mode) {
  if (typeof number !== 'string' || !/^\+?[0-9]{1,32}$/.test(number.trim()) || !['auto', 'collaboration'].includes(mode)) throw new Error('Please enter a valid hotline number.')
  return `?${new URLSearchParams({ calledNumber: number.trim(), callType: mode })}`
}
export function waitDescription(row) {
  if (!Number.isInteger(row.maxWaitTime) || row.maxWaitTime < 0) return 'Unconfirmed'
  if (row.maxWaitTimeExplicit === true) return `${row.maxWaitTime}s (explicitly set)`
  if (row.maxWaitTimeExplicit === false) return `Not explicitly set (API returned ${row.maxWaitTime}s)`
  return `${row.maxWaitTime}s (unconfirmed whether explicitly set)`
}
export function queueLimit(value) {
  return value === 0 ? 'Unlimited queue length' : Number.isInteger(value) && value > 0 ? `${value} calls` : 'Unconfirmed'
}
